import { render, staticRenderFns } from "./ShareHolderAndManagementInfo.vue?vue&type=template&id=92b91770&scoped=true"
import script from "./ShareHolderAndManagementInfo.vue?vue&type=script&lang=js"
export * from "./ShareHolderAndManagementInfo.vue?vue&type=script&lang=js"
import style0 from "./ShareHolderAndManagementInfo.vue?vue&type=style&index=0&id=92b91770&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b91770",
  null
  
)

export default component.exports